export default "__VITE_ASSET__B82w3cAw__"